import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { UserService } from '../../services/user-service';
import { AuthService } from '../../services/auth-service';
import { InsightsService } from '../../services/insights-service';

import { environment } from '../../environments/_active-environment/environment';

import { AccountComponent } from '../../app/account/account.component';
import { PreferencesComponent } from '../preferences/preferences.component';
import { NotificationManageComponent } from '../../app/_shared/components/notification-manage/notification-manage.component';
import { WelcomeMessageComponent } from '../../app/welcome-message/welcome-message.component';
import { TutorialsComponent } from '../tutorials/tutorials.component';

@Component({
  selector: 'app-profile-creation-background',
  templateUrl: './profile-creation-background.component.html',
  styleUrls: ['./profile-creation-background.component.scss'],
  standalone: false
})
export class ProfileCreationBackgroundComponent {
  private hasOpenedProfileModal = false;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private insightsService: InsightsService,
    private modalService: NgbModal,
    private router: Router,
  ) {
    this.checkUserProfileCreationRequired();
  }

  /**
   * Checks if the user needs to create a profile. If so, opens the account modal.
   * If the user already has a profile, redirects to home or insights.
   * Guards against opening the modal more than once.
   */
  checkUserProfileCreationRequired(): void {
    // this.showBackgroundForUserProfileModal(company);
    const { user } = this.userService;

    if (!user) {
      this.authService.logout();
      return;
    }

    if (this.userService.hasProfile()) {
      this.router.navigateByUrl(this.insightsService.isInsightsDomain() ? '/insights' : '/home');
      return;
    }

    if (this.hasOpenedProfileModal) {
      return;
    }
    this.hasOpenedProfileModal = true;
    this.userService.setProfileOnboardingInProgress(true);

    const profileModal = this.modalService.open(AccountComponent, {
      backdrop: 'static',
      keyboard: false,
    });
    profileModal.componentInstance.temporaryToken = this.userService.temporaryToken;
    profileModal.result.then(() => {
      this.userService.userId = user && user.id;
      this.userService.envVariables = environment;

      if (this.insightsService.isInsightsDomain()) {
        // skip other modals for insights domain; redirect to request-access after creating profile
        this.userService.setProfileOnboardingInProgress(false);
        this.router.navigateByUrl('/request-access');
        this.modalService.dismissAll();
        return;
      }

      const preferencesModal = this.modalService.open(PreferencesComponent, {
        backdrop: 'static',
        keyboard: false,
      });
      preferencesModal.result.then(() => {
        const notificationsMgtModal = this.modalService.open(NotificationManageComponent, {
          backdrop: 'static',
          keyboard: false,
        });
        notificationsMgtModal.result.then(() => {
          this.launchWelcomeMessage();

          this.userService.setProfileOnboardingInProgress(false);
          this.router.navigateByUrl('/home');
        });
      })
        .catch(err => {
          this.userService.setProfileOnboardingInProgress(false);
          console.log('preferencesModal catch(): ' + err);
        });
    })
      .catch(err => {
        this.userService.setProfileOnboardingInProgress(false);
        console.log('profileModal catch():', err);
      });
  }

  private launchWelcomeMessage() {
    const welcomeModal = this.modalService.open(WelcomeMessageComponent, {
      backdrop: 'static',
      keyboard: false,
    });
    welcomeModal.componentInstance.companyWelcomeText = this.userService.company.welcomeText;
    welcomeModal.componentInstance.companyWelcomeTextLink = this.userService.company.welcomeTextLink;
    welcomeModal.result
      .then(($event) => {
        if ($event === 'showTutorial') {
          const modal = this.modalService.open(TutorialsComponent);
          modal.result.then(() => {
            location.reload();
          })
            .catch(() => {
              location.reload();
            });
        }
      })
      .catch(() => {
        console.log('Clicked outside of modal');
      });
  }

}
